import { revisions as _revisions } from "../../standardAttachables.js";
import { reviseSafetyMonitoringReport } from "./actions.js";

export const monitoringRevisions = {
    ..._revisions,
    "headers": [_revisions.headers[0], _revisions.headers[1]],
    "actions": [{
        "label": "Revise Safety Monitoring Report",
        "action": reviseSafetyMonitoringReport
    }],
    "rowActions": [{
        "label": "Download",
        async action({ pageItem, rowItem, db }) {
            let url = await db.download(`Database/SafetyMonitoringReports/${pageItem.ID}/Revisions/${rowItem.ID}/${rowItem.File}`);
            window.open(url, "fileView", "popup");
        }
    }]
};

export default [monitoringRevisions];
